import { Request } from '../../Servidor/Request';

export class PendencyReasonRequest {
    private sgepdenguependencia: number;
    private nome: string;
    private codigo: string

    constructor(sgepdenguependencia: number, nome: string, codigo: string) {
        this.sgepdenguependencia = sgepdenguependencia;
        this.nome = nome;
        this.codigo = codigo;
    }


    /**
     * Getter sgepdenguependencia
     * @return {number}
     */
    public getSgepdenguependencia(): number {
        return this.sgepdenguependencia;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
     /**
     * Getter codigo
     * @return {string}
     */
    public getCodigo(): string {
        return this.codigo;
    }
}

export class PendencyReasonStructRequest {
    private sgepdenguependencia: number;

    constructor(sgepdenguependencia: number) {
        this.sgepdenguependencia = sgepdenguependencia;
    }


    /**
     * Getter sgepdenguependencia
     * @return {number}
     */
    public getSgepdenguependencia(): number {
        return this.sgepdenguependencia;
    }

}

export class PendencyReasonStructResponse {
    private sgepdenguependencia: number;
    private nome: string;

    constructor(sgepdenguependencia: number, nome: string) {
        this.sgepdenguependencia = sgepdenguependencia;
        this.nome = nome;
    }


    /**
     * Getter sgepdenguependencia
     * @return {number}
     */
    public getSgepdenguependencia(): number {
        return this.sgepdenguependencia;
    }

    /**
     * Getter nome
     * @return {string}
     */
    public getNome(): string {
        return this.nome;
    }
}

export class PendencyReasonInteractor {
    public fetchSave(request: PendencyReasonRequest): PromiseLike<Boolean> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/pendencia/salvar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                let response = rs.Status == "Sucesso"
                res(response)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchDataOne(request: PendencyReasonStructRequest): PromiseLike<PendencyReasonStructResponse> {
        return new Promise((res, rej) => {
            return new Request().requestPost("dengue/pendencia/buscar", request).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}